/**
 * Seller-facing sell journey strings.
 * Screens import these in later phases. This module does not render UI.
 * Success-page copy stays in sellSuccessCopy (D5).
 */

export const sellJourneyCopy = {
  reviewPromise: "We usually review within 24 hours, often sooner.",
  pageTitle: "List an item for review",
  pageSubline: "It goes live after we review it.",
  pageTitleBulk: "List multiple items",
  pageSublineBulk:
    "Enter location and pickup once, then complete each listing. Review everything together when you are ready — up to 10 items per batch.",
  introTitle: "Before you list",
  introQualityLine: "We check quality and safety first.",
  introStartCta: "Start listing",
  categoryCaution:
    "Choose the right category; an item in a wrong category will be deleted without question.",
  quantityHelper:
    "More than one of this same item. A different product is a separate listing.",
  titleHint:
    "Your title is generated from the details you provided and cannot be changed, so it always matches what buyers see in search.",
  emptyDetailsLine: "No additional details required for this category.",
  pickupHeading: "When can buyers pickup?",
  pickupHelper: "Days and hours — buyers use this to meet you.",
  optionalDetailsHeading: "Tell buyers more (optional)",
  requestBannerTitle: "Someone is looking for this",
  requestBannerBody:
    "We filled in details from their request. Check them, and change anything that does not match your item, before you submit.",
  rulesLead: "By listing on Sell It Off you agree:",
  rulesOwnItem: "You own this item",
  rulesAccurate: "The details are accurate",
  rulesReply: "You will reply within a day",
  rulesFee: "You accept the 10% fee",
  rulesAgree: "You agree to these rules",
  rulesTermsLink: "Read the full terms",
  submitForReview: "Submit for review",
  availabilityLine:
    "The list only includes what we can sell right now. If your item isn’t there, don’t list it yet.",
  availabilitySeeExamples: "See examples",
  availabilityExamplesHeading: "Examples of what we can’t accept yet",
  photoRoleFront:
    "Front — main image buyers will see, it must be sharp and clear",
  photoRoleFlaw:
    "Side — show another side of the item, or a flaw (if applicable)",
  photoRoleAngle: "Another angle — to add more clarity and detail for buyers",
  stepCategory: "Category",
  stepDetails: "Details",
  stepTitle: "Title",
  stepPrice: "Price",
  stepPhotos: "Photos",
  stepExtras: "Extras",
  addAnotherItem: "Add another item",
  reviewBatch: "Review batch",
  photosNotCopied: "Photos are not copied when you duplicate.",
  itemNeedAnother: "add one more",
} as const;

export const sellJourneyRuleLines = [
  sellJourneyCopy.rulesOwnItem,
  sellJourneyCopy.rulesAccurate,
  sellJourneyCopy.rulesReply,
  sellJourneyCopy.rulesFee,
  sellJourneyCopy.rulesAgree,
] as const;

export const sellJourneyPhotoRoles = [
  sellJourneyCopy.photoRoleFront,
  sellJourneyCopy.photoRoleFlaw,
  sellJourneyCopy.photoRoleAngle,
] as const;
